import React, {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    Box,
    Dialog,
    IconButton,
    Button,
    Slide,
    Theme,
    Toolbar,
    Paper,
    Typography,
    Card,
    CardContent,
    CardHeader,
    CardActions,
    Divider,
    Grid,
    LinearProgress
} from "@mui/material";
import {CloseRounded} from "@mui/icons-material";
import {useTheme} from '@mui/material/styles';
import {useParams} from "react-router-dom";
import {ContainerClasses} from '../../themes/containerClasses'
import MonitorIcon from '@mui/icons-material/Monitor';
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {ListSelectorComponent} from "../../components/listSelector/ListSelector";
import {ErrorComponent} from "../../components/error/Error";
import {ChartComponent} from "../../components/dashboard/Chart";
import {ListComponent} from "../../components/list/List";
import {ListViewModel,
        ListViewFilterModel,
        ActionModel,
        ApplicationPageModel,
        ApplicationPageElementTypeModel} from "../../models/models";
import {DashboardScreenElementModel,
        SearchScreenElementModel} from '../../models/modelsScreenElements';
import {SortOrderModel,
        BarChartUIPreferenceModel} from '../../models/modelsUserConfiguration';
import {setSelectedTabObject} from "../../app/globalLayoutSlice";
import {getAppName,
        getObjectName} from "../../utils/helperRouter";
import { useNavigate } from "react-router";
import { useAuth } from "../../hooks/useAuth";
import { ActionsComponent } from "../../components/actions-o/Actions";
import {selectApplicationPages,
        selectIsFetching} from "../app/appSlice";

export const AppPageScreen = () => {

  let {appName, appPageName} = useParams();

  const theme = useTheme();
  const styles = ContainerClasses();
  const {accessToken, onInvalidToken} = useAuth();

  const [error, setError] = useState<string | null>(null);

  const applicationPages = useSelector(selectApplicationPages);
  const [selectedAppPage, setSelectedAppPage] = useState<ApplicationPageModel | null>(null);

  useEffect(() => {
    //find in application pages
    const thisPage = applicationPages.find((appPage: ApplicationPageModel) => appPage.ApiName_sys===appPageName)
    if(appPageName &&
       thisPage){
         setError(null)
         setSelectedAppPage(thisPage)
    }
  }, [appPageName, applicationPages]); // eslint-disable-line react-hooks/exhaustive-deps

 const PageElementComponent: React.FC<{
    element: ApplicationPageElementTypeModel
  }> = ({
    element
  }) => {

    const dashboardElement = (thisElement: DashboardScreenElementModel) => {
      return (
          <Card
            sx={styles.containerCard}
          >
            <Box sx={styles.containerRowA}>
              <Typography variant="h6">
                {element.Label_sys}
              </Typography>
            </Box>
            <CardContent>
            <ChartComponent
              data={thisElement.chart}
            />
            </CardContent>
          </Card>
      )
    }

    const searchElement = (thisElement: SearchScreenElementModel) => {
      return (
          <Card
            sx={styles.containerCard}
          >
            <Box sx={styles.containerRowA}>
              <Typography variant="h6">
                {element.Label_sys}
              </Typography>
            </Box>
            <CardContent sx={{color: 'red'}}>
              Component type Search currently implemented as a "CustomPage"
            </CardContent>
          </Card>
      )
    }

    const missingElement = (thisElement: ApplicationPageElementTypeModel) => {
      return (
          <Card
            sx={styles.containerCard}
          >
            <Box sx={styles.containerRowA}>
              <Typography variant="h6">
                {element.Label_sys}
              </Typography>
            </Box>
            <CardContent sx={{color: 'red'}}>
              Component type not yet implemented: {element.Type_sys}
            </CardContent>
          </Card>
      )

    }


    switch(element.Type_sys){
      case "Chart":
        return dashboardElement(element as DashboardScreenElementModel)
      case "Search":
        return searchElement(element as SearchScreenElementModel)
      default:
        return missingElement(element)
    }
  }

  return (

     <Box>
       {
         error &&
         <ErrorComponent
           errorMessage = {error}
         />
       }

       <Grid
        container
        spacing={2}
       >
         {
           selectedAppPage?.pageElements.map((thisPageElement: ApplicationPageElementTypeModel) => {
             return (
               <Grid
                 item
                 key={thisPageElement.Uuid_sys}
                 xs={12}
                 md={thisPageElement.Width_sys}
               >
                 <PageElementComponent
                   element={thisPageElement}
                 />
                </Grid>
             )
           })
         }

       </Grid>



     </Box>

);
};
